import Request from '@/plugins/request'

export function getUsers(params) {
  return Request.get('users', {
    params,
  })
}

export function getChildren(id, params) {
  return Request.get(`users/${id}/children`, {
    params,
  })
}

export function getUpgradeActivity(id, params) {
  return Request.get(`users/${id}/upgrade-activity`, {
    params,
  })
}

// 获取代理汇总信息
export function getTeamCount(id) {
  return Request.get(`users/${id}/team-count`)
}

// 修改会员等级
export function upgradeLevel(id, params) {
  return Request.put(`users/${id}/upgrade-level`, params)
}

// 修改推荐上线
export function changeParent(id, params) {
  return Request.put(`users/${id}/change-parent`, params)
}
// 修改安置上线
export function changePositParent(id, params) {
  return Request.put(`users/${id}/change-posit-parent`, params)
}
// 修改手机号
export function changeMobile(id, params) {
  return Request.put(`users/${id}/change-mobile`, params)
}
// 更改推荐奖励资格
export function toggleAllowInviteRebate(id, params) {
  return Request.put(`users/${id}/toggle-allow-invite-rebate`, params)
}
// 更改复销奖励资格
export function toggleAllowOrderRebate(id, params) {
  return Request.put(`users/${id}/toggle-allow-order-rebate`, params)
}
// 更改基金分红资格
export function toggleAllowShareFund(id, params) {
  return Request.put(`users/${id}/toggle-allow-share-fund`, params)
}

// 修改状态
export function updateUserOtherStatus(id, params) {
  return Request.put(`users/${id}/change-other-status`, params)
}

// 设置密码
export function changePassword(id, params) {
  return Request.put(`users/${id}/change-password`, params)
}
// 解绑微信
export function unbindWechat(id) {
  return Request.put(`users/${id}/unbind-wechat`, {})
}
// 修改复销余额,奖金,报单余额
export function modifyWallet(id, params) {
  return Request.put(`users/${id}/modify-wallet`, params)
}
// 审核
export function audit(id, params) {
  return Request.put(`users/${id}/audit`, params)
}

export function createUser() {
  return Request.get(`users/create`)
}

export function storeUser(data) {
  return Request.post('users', data)
}

export function updateUser(id, data) {
  return Request.put(`users/${id}`, data)
}

export function editUser(id) {
  return Request.get(`users/${id}/edit`)
}

export function destroyUser(id) {
  return Request.delete(`users/${id}`)
}

export function shareBonus(params) {
  return Request.post(`users/share-bonus`, params)
}
